import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {Container} from 'reactstrap';
import Header from '../../components/Header/';
import Sidebar from '../../components/Sidebar/';
import Breadcrumb from '../../components/Breadcrumb/';
import Aside from '../../components/Aside/';
import Footer from '../../components/Footer/';
import Dashboard from '../../views/Dashboard/';
import Charts from '../../views/Charts/';
import Widgets from '../../views/Widgets/';

// Components
import StoryCreatingPage from '../../views/Components/StoryCreating/';
import StoryboardAssetsPage from '../../views/Components/StoryboardAssets/';
import StoryRequestPage from '../../views/Components/RequestStoryboard/';
import AccountAndBillingPage from '../../views/Components/AccountAndBilling/';
import UploadDetailsPage from '../../views/Components/UploadDetails/';
import LiveStoryboardDetailsPage from '../../views/Components/LiveStoryboardDetails/';
import StoryboardDetailsPage from '../../views/Components/StoryboardDetails/';
import StoreStoryboardDetailsPage from '../../views/Components/StoreStoryboardDetails/';
import YourStoryboardsPage from '../../views/Components/YourStoryboards/';
import StatusPage from '../../views/Components/Social/';
import StoryboardEditPage from '../../views/Components/StoryboardEdit/';
import Upgrade from '../../views/Components/Upgrade/';
import Cards from '../../views/Components/Cards/';
// import Forms from '../../views/Components/Forms/';
import Modals from '../../views/Components/Modals/';
import SocialButtons from '../../views/Components/SocialButtons/';
import Switches from '../../views/Components/Switches/';
import Tables from '../../views/Components/Tables/';
import Tabs from '../../views/Components/Tabs/';

// Icons
import FontAwesome from '../../views/Icons/FontAwesome/';
import SimpleLineIcons from '../../views/Icons/SimpleLineIcons/';

// Forms
import BasicForms from '../../views/Forms/BasicForms/';
import AdvancedForms from '../../views/Forms/AdvancedForms';

// Editors
import TextEditors from '../../views/Editors/TextEditors';
import CodeEditors from '../../views/Editors/CodeEditors';

// Plugins
import Calendar from '../../views/Plugins/Calendar/';
import LoadingButtons from '../../views/Plugins/LoadingButtons/';
import Notifications from '../../views/Plugins/Notifications/';
import Spinners from '../../views/Plugins/Spinners/';

// UI Kits
import Invoice from '../../views/UI-Kits/Invoicing/';
import Inbox from '../../views/UI-Kits/Email/Inbox/';
import Message from '../../views/UI-Kits/Email/Message/';
import Compose from '../../views/UI-Kits/Email/Compose/';

// Redux
import { connect } from 'react-redux';
import $ from 'jquery';

class Full extends Component {
  
  constructor(props) {
    super(props);
     this.state = {
      result:Object,
      isCampaign: false,
      isCorporate: false,
      isManagedEnterprise: false
    };
  }

  componentWillMount() {
    let authToken = this.props.user.authToken;

     $.ajax({
          url: `https://screen.mobflic.com/v1/current-user`,
          type: 'GET',
          beforeSend: function (xhr) {
                  xhr.setRequestHeader ("X-Auth-Token",authToken);
          },
          success: (res) => {
            let type = res.result.customerType;

            if(type == 'enterprise' || type== 'managed'){
              this.state.isManagedEnterprise = true;
            }else if(type == 'corporate'){
              this.state.isCorporate = true;
            }else{
              this.state.isCampaign = true;
            }

            // this.setState({
            //   result:res.result
            // })
         },
        error: (res,a,b) => {
            console.log(res);
        }

      });
  }


  render() {
    
    // const managedRoute = <Route path="/Metrics" name="Buttons" component={StatusPage} />;
    const corporateRoute = 
                <span>
                <Route path="/Assets" name="Dashboard" component={StoryboardAssetsPage}/>
                </span>;

    return (
      <div className="app">
        <Header />
        <div className="app-body">
          <Sidebar {...this.props}/>
          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                {/* Campaign */}
                <Route path="/dashboard" name="Dashboard" component={Dashboard}/>
                <Route path="/storyCreating/StoryRequest" name="Dashboard" component={StoryRequestPage}/>
                <Route path="/storyCreating/details/:Id" name="Buttons" component={StoreStoryboardDetailsPage}/>
                <Route path="/StoryCreating" name="Buttons" component={StoryCreatingPage}/>
                <Route path="/Account" name="Buttons" component={AccountAndBillingPage}/>
                <Route path="/Upgrade" name="Dashboard" component={Upgrade} />
                <Route path="/YourStoryboards/Edit/:Id" name="Buttons" component={StoryboardEditPage}/>
                <Route path="/YourStoryboards/Upload" name="Buttons" component={UploadDetailsPage}/>
                <Route path="/YourStoryboards/LiveDetails/:Id" name="Buttons" component={LiveStoryboardDetailsPage}/>
                <Route path="/YourStoryboards/details/:Id" name="Buttons" component={StoryboardDetailsPage}/>
                <Route path="/YourStoryboards" name="Buttons" component={YourStoryboardsPage}/>

                {/* Corporate */}
                { (this.state.isCorporate || this.state.isManagedEnterprise ) &&  corporateRoute }

                {/* Enterprise/Managed */}
                { this.state.isManagedEnterprise }


                <Redirect from="/" to="/dashboard"/>
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
      user: state.activeUser,
  };
}

export default connect(mapStateToProps)(Full);



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js